import { handleActions } from 'redux-actions';
import { clearLeftStatementContent } from 'store/actions/statement-content-actions';
import { leftElementDatapartStoreAction } from 'store/actions/left-statement-content-actions';
import ElementDataParts from 'models/api/element-dataparts-model';

export default handleActions(
  {
    [leftElementDatapartStoreAction]: (dataPartsModel, { payload }) => {
      const { response } = payload;
      return dataPartsModel.updateDatapartElements({ response });
    },
    [clearLeftStatementContent]: () => {
      return new ElementDataParts();
    },
  },
  new ElementDataParts(),
);
